export default [
  {
    path: '/gamificacao',
    name: 'gamification-campaigns',
    component: () => import('@/views/gamification/GamificationCampaigns.vue'),
    meta: {
      pageTitle: 'Gamificação',
      action: 'read',
      resource: 'MenuGamificacao',
      breadcrumb: [
        { text: 'Gamificação', active: false },
        { text: 'Campanhas', active: true },
      ],
    },
  },
  {
    path: '/gamificacao/dashboard',
    name: 'gamification-dashboard',
    component: () => import('@/views/gamification/GamificationDashboard.vue'),
    meta: {
      pageTitle: 'Gamificação - Dashboard',
      action: 'read',
      resource: 'MenuGamificacao',
      breadcrumb: [
        { text: 'Gamificação', active: false },
        { text: 'Dashboard', active: true },
      ],
    },
  },
  {
    path: '/gamificacao/:id',
    name: 'gamification-campaign-detail',
    component: () => import('@/views/gamification/GamificationCampaignDetail.vue'),
    meta: {
      pageTitle: 'Gamificação - Campanha',
      action: 'read',
      resource: 'MenuGamificacao',
      breadcrumb: [
        { text: 'Gamificação', active: false },
        { text: 'Campanhas', to: '/gamificacao' },
        { text: 'Detalhe', active: true },
      ],
    },
  },
];
